(function($, Drupal) {

  Drupal.behaviors.imageHotSpotsMobile = {
    attach: function(context) {

      $(document).off('mouseenter.imageHotspots').on(
          'mouseenter.imageHotspotsMobile',
          '.paragraph--type--image-hotspots:not(.show-all-content) .paragraph--type--image-hotspot-item-mobile .agent-hotspot-base__dots-overlay .agent-hotspot-base__dot',
          function() {

            const $dot = $(this);

            $dot.trigger('click');

            $('.paragraph--type--image-hotspot-item-mobile .agent-hotspot-base__dot').removeClass('active');
            $dot.addClass('active');

            const dotRect = this.getBoundingClientRect();

            const overlay = $dot
            .closest('.paragraph--type--image-hotspot-item-mobile')
            .find('.overlay')[0];

            if (!overlay) {
              return;
            }

            const overlayRect = overlay.getBoundingClientRect();

            if (window.innerWidth < 992) {

              const dotCenterY = dotRect.top + (dotRect.height / 2);
              const lineHeight = overlayRect.top - dotCenterY;

              this.style.setProperty('--line-height', `${lineHeight}px`);
              this.style.removeProperty('--line-width');
            }
            else {

              // mobile
              const dotCenterX = dotRect.left + (dotRect.width / 2);

              const lineWidth = overlayRect.left - dotCenterX;

              this.style.setProperty('--line-width', `${lineWidth}px`);
              this.style.removeProperty('--line-height');
            }

            setTimeout(function() {
              const $sidebar = $('.agent-hotspot-base__sidebar.agent-hotspot-base__sidebar--active');

              if ($sidebar.length) {
                $('.paragraph--type--image-hotspots .paragraph--type--image-hotspot-item-mobile .overlay .mobile-content')
                .empty()
                .append($sidebar.html());
              }
            }, 10);

            setTimeout(function() {
              const $modal = $('.agent-hotspot-base__modal-overlay.agent-hotspot-base__modal-overlay--active');

              if ($modal.length) {
                $('.paragraph--type--image-hotspots .paragraph--type--image-hotspot-item-mobile .overlay .mobile-content')
                .empty()
                .append($modal.html());
              }
            }, 10);
          }
      );
    },
  };

})(jQuery, Drupal);